import { render, staticRenderFns } from "./FormPerForm.vue?vue&type=template&id=5d97cfae&scoped=true"
import script from "./FormPerForm.vue?vue&type=script&lang=js"
export * from "./FormPerForm.vue?vue&type=script&lang=js"
import style0 from "./FormPerForm.vue?vue&type=style&index=0&id=5d97cfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97cfae",
  null
  
)

export default component.exports